import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import ArrowDownSmall from '@icons/arrow/ArrowDownSmall';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    note: string;
}

function CouponNote({ note }:Props) {
    const { t } = useTranslation('coupon');
    const [isOpen, setIsOpen] = useState<boolean>(true);
    return (
        <Container fullWidth spacing={2}>
            <Toggle type='button'
                aria-expanded={isOpen}
                onClick={() => setIsOpen((prev) => !prev)}>
                <Text fontWeight='medium' color='var(--color-text-secondary)'>
                    {t('detail.note')}
                </Text>
                <Arrow isOpen={isOpen}
                    size={16}
                    color='var(--color-gray7)'/>
            </Toggle>
            {isOpen && (
                <NoteContents as='div'
                    size='body-long'
                    color='var(--color-text-secondary)'
                    dangerouslySetInnerHTML={{ __html: note }} />
            )}
        </Container>
    );
}

const Container = styled(Column)`
    margin-bottom: 64px;
    padding: var(--spacing-4);
`;

const Toggle = styled.button`
    align-items: center;
    background: none;
    display: flex;
    justify-content: space-between;
    padding: 0;
    width: 100%;
`;

const Arrow = styled(ArrowDownSmall, {
    shouldForwardProp: (prop) => prop !== 'isOpen',
})<{ isOpen: boolean }>`
    transform: rotate(${({ isOpen }) => (isOpen ? 180 : 0)}deg);
    transition: transform 200ms ease-in-out;
`;

const NoteContents = styled(Text)`
    max-width: 100%;
    white-space: pre-wrap;
    word-break: break-word;
    * {
        white-space: pre-wrap;
    }

    ul {
        list-style-type: disc;
        list-style-position: outside;
        display: block;
        padding-left: 18px;
    }

    ol {
        list-style-type: decimal;
        list-style-position: outside;
        padding-left: 18px;
    }

    li {
        display: list-item;
    }

    h1, h2, h3 {
        font-weight: 400;
    }

    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    h3 {
        font-size: 16px;
    }

    p {
        font-size: var(--font-size-body-long);

        &:empty {
            min-height: 1em;
            margin: 0;
        }
    }
`;

export default CouponNote;
